import { queryOptions, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { joinKeyQueryKeys, JoinKeys } from '#api';
import { makeMaxResourceQueryFn } from '#util/api.ts';

export const maxJoinKeysQueryOptions = queryOptions({
  queryKey: joinKeyQueryKeys.maxList,
  queryFn: makeMaxResourceQueryFn(JoinKeys.getJoinKeys),
});

export function useSuspenseMaxJoinKeysQuery() {
  return useSuspenseQuery(maxJoinKeysQueryOptions);
}

export function useSuspenseJoinKeyQuery(joinKeyID: string) {
  const queryClient = useQueryClient();

  return useSuspenseQuery({
    queryKey: joinKeyQueryKeys.detail(joinKeyID),
    queryFn: ({ signal }) => JoinKeys.getJoinKey(joinKeyID, { signal }),
    // Seed from the list query when the key is already there, so the detail page renders without a spinner
    initialData: () => {
      const joinKey = queryClient.getQueryData(maxJoinKeysQueryOptions.queryKey)?.data.find((k) => k.id === joinKeyID);
      if (joinKey) {
        return { data: joinKey };
      }
    },
    initialDataUpdatedAt: () => queryClient.getQueryState(maxJoinKeysQueryOptions.queryKey)?.dataUpdatedAt,
  });
}
